import React from 'react';
import { ChannelExcludedCarrierServicesTemplate } from 'themes/modules/channel/pages';
import { ChannelExcludedCarrierServicesViewStore } from 'modules/channel/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new ChannelExcludedCarrierServicesViewStore(rootStore, componentProps),
	'channelExcludedCarrierServicesViewStore'
)
class ChannelExcludedCarrierServices extends React.Component {
	render() {
		return (
			<ChannelExcludedCarrierServicesTemplate
				{...this.props}
				viewStore={this.props.channelExcludedCarrierServicesViewStore}
			/>
		);
	}
}

export default ChannelExcludedCarrierServices;
